module.exports = {
	"library.footer.terms_of_use": "Nutzungsbedingungen",
	"library.footer.terms_and_conditions": "Allgemeine Geschäftsbedingungen",
	"library.footer.privacy_policy": "Datenschutzrichtlinie",
	"library.footer.get_to_know_us": "Kontakt zu Universe",
	"library.footer.about": "Über uns",
	"library.footer.jobs": "Karriere",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Hilfe",
	"library.footer.find_events": "Events finden",
	"library.footer.top_events": "Top-Events",
	"library.footer.host_events": "Events veranstalten",
	"library.footer.become_a_host": "Veranstalter werden",
	"library.footer.tour": "Tour",
	"library.footer.embeddable_widgets": "Einbettbare Widgets",
	"library.footer.customers": "Kunden",
	"library.footer.pricing": "Preisgestaltung",
	"library.footer.get_the_onsite_app": "Scan-App herunterladen",
	"library.footer.developers": "Entwickler",
	"library.footer.contact_us": "Kontakt"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/de.json
// module id = 1575
// module chunks = 0 1 2 3 5 6 7 8 9 10 11 12 13 14 15 16